import { useExperimentalStyling } from '~/context/experimentalStylingContext'
import { cn } from '~/utils/tailwind-utils'

export const LabelInputContainer = ({
  label,
  children,
  isInputContainer = true,
}: {
  label: string
  children: React.ReactNode
  isInputContainer?: boolean
}) => {
  const { enableExperimentalStyling } = useExperimentalStyling()

  if (enableExperimentalStyling) {
    return (
      <div className="flex w-full flex-col space-y-2">
        <span className="text-sm font-medium text-primary">{label}</span>
        {children}
      </div>
    )
  }
  return (
    <div
      className={cn(
        'focus relative rounded-lg border border-gray-200 px-3 py-2 transition focus-within:border-gray-400 dark:border-gray-700 dark:focus-within:border-gray-600',
        {
          'hover:border-gray-400 dark:hover:border-gray-600': isInputContainer,
        },
      )}
    >
      <div className="text-secondary">
        <label className="text-xs font-medium">{label}</label>
      </div>
      {children}
    </div>
  )
}
